export default "__VITE_ASSET__$w6dfNsk__"